import { ComponentType } from 'react';
import dynamic from 'next/dynamic';
import UpgradeProgramType from '@/constants/upgrade-program-type';

// What every flow gets from the host
export interface NuFlowProps {
  open: boolean;
  onClose: () => void;
}

// Flows (e.g. drawers from upgrade/exchange program) that open over any page with ?nuFlow=<id>; register new ones here.
// Loaded on demand, so pages only download the flow a link asks for.
export const NU_FLOWS: Partial<Record<string, ComponentType<NuFlowProps>>> = {
  [UpgradeProgramType.KP2NFC_TAMPER_EXCHANGE]: dynamic(() =>
    import('@/ui/components/kp2nfc-tamper-exchange/kp2nfc-tamper-exchange-overlay').then(
      (overlayModule) => overlayModule.Kp2NfcTamperExchangeOverlay,
    ),
  ),
};
